import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function EmotionalBenefit() {
  return <section className="py-20 px-4 bg-orange-500 text-white text-center" data-id="element-17">
      <FadeIn className="max-w-4xl mx-auto" data-id="element-18">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight mb-6" data-id="element-19">
          Stop overpaying for the same product.
        </h2>
        <p className="text-xl md:text-2xl font-medium text-orange-50 leading-relaxed mb-4" data-id="element-20">
          Most homeowners overpay by hundreds simply because they don't compare.
          Don't be one of them.
        </p>
        <p className="text-lg md:text-xl text-orange-100 leading-relaxed" data-id="element-21">
          In just minutes, you'll know the real price… and choose with
          confidence.
        </p>
      </FadeIn>
    </section>;
}